(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1424],{

/***/ 58577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
}), 'Business'));

/***/ }),

/***/ 7354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
}), 'Cloud'));

/***/ }),

/***/ 96564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infrastructure",
      function () {
        return __webpack_require__(8610);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57180);








var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles);
function Loading(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            children: "Carregando...."
        })
    });
}


/***/ }),

/***/ 8610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Infrastructure; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41120);
/* harmony import */ var components_Functions_Loading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24552);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(538);
/* harmony import */ var pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75994);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58577);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7354);
/* harmony import */ var lang_lang_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34426);







var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(5121), __webpack_require__.e(1788), __webpack_require__.e(7298)]).then(__webpack_require__.bind(__webpack_require__, 37298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37298)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    }
});

// Sections for this page

var DataCenterSection = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 9136).then(__webpack_require__.bind(__webpack_require__, 69136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69136)
            ];
        }
    }
});
var NetworkSection = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1758), __webpack_require__.e(7836)]).then(__webpack_require__.bind(__webpack_require__, 97836));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97836)
            ];
        }
    }
});
var GridContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    },
    ssr: false
});
var GridItem = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 6680).then(__webpack_require__.bind(__webpack_require__, 96680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96680)
            ];
        }
    }
});
var NavPills = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9331), __webpack_require__.e(2968), __webpack_require__.e(3507)]).then(__webpack_require__.bind(__webpack_require__, 3507));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3507)
            ];
        }
    }
});


var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
var SEO = {
    title: "BB Host - Infraestrutura",
    description: "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a opera\xe7\xe3o.",
    url: "https://www.bbhost.com.br/infrastructure",
    type: "website",
    languageAlternates: [
        {
            hrefLang: "en",
            href: "https://www.bbhost.com.br/en/infrastructure"
        },
        {
            hrefLang: "es",
            href: "https://www.bbhost.com.br/es/infrastructure"
        }
    ]
};
var TabIndex = {
    0: "datacenter",
    1: "network"
};
function getIndex() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    switch(name){
        case "network":
            return 1;
        case "datacenter":
        default:
            return 0;
    }
}
var __N_SSG = true;
function Infrastructure(props) {
    var classes = useStyles();
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var tabs = [
        {
            tabButton: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_8__/* .trans */ .d)("infrastructure::tabs.datacenter"),
            tabIcon: _material_ui_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
            tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DataCenterSection, {})
        },
        {
            tabButton: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_8__/* .trans */ .d)("infrastructure::tabs.network"),
            tabIcon: _material_ui_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
            tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NetworkSection, {})
        }
    ];
    var activeIndex = getIndex(query.index);
    if (query.index != undefined && [
        "network",
        "datacenter"
    ].includes(query.index)) {
        SEO.url += "https://www.bbhost.com.br/infrastructure/".concat(query.index);
        SEO.languageAlternates[0].href = "https://www.bbhost.com.br/en/infrastructure/".concat(query.index);
        SEO.languageAlternates[1].href = "https://www.bbhost.com.br/es/infrastructure/".concat(query.index);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                name: "infrastructure",
                seo: SEO
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(classes.main, classes.mainRaised),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.container,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.section,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridContainer, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavPills, {
                                    color: "info",
                                    alignCenter: true,
                                    tabs: tabs,
                                    active: activeIndex,
                                    tabIndex: TabIndex
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);
/* harmony import */ var _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89395);




var teamStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    section: {
        padding: "20px 0",
        textAlign: "center"
    },
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    })
}, _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    itemGrid: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    cardTitle: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .cardTitle */ .X5,
    smallTitle: {
        color: "#6c757d"
    },
    description: {
        color: "#999"
    },
    justifyCenter: {
        justifyContent: "center !important"
    },
    socials: {
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
        color: "#999"
    },
    margin5: {
        margin: "5px"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (teamStyle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4888,8653,9774,2888,179], function() { return __webpack_exec__(96564); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);